// Initialize MooSend tracking script
export const initMooSend = () => {
  if (!window.mootrack) {
    const initializeMooSend = (t, n, e, o, a) => {
      const d = (t) => {
        const n = ~~(Date.now() / 3e5);
        const o = document.createElement(e);
        o.async = true;
        o.src = t + "?ts=" + n;
        const a = document.getElementsByTagName(e)[0];
        a.parentNode.insertBefore(o, a);
      };

      t.MooTrackerObject = a;
      t[a] = t[a] || function() {
        if (t[a].q) {
          t[a].q.push(arguments);
        } else {
          t[a].q = [arguments];
        }
      };

      if (window.attachEvent) {
        window.attachEvent("onload", d.bind(this, o));
      } else {
        window.addEventListener("load", d.bind(this, o), false);
      }
    };

    initializeMooSend(
      window,
      document,
      "script",
      "https://cdn.stat-track.com/statics/moosend-tracking.min.js",
      "mootrack"
    );
  }
};

// Load inline form
export const loadInlineForm = () => {
  if (window.mootrack) {
    window.mootrack('loadForm', '55e68caca5f94d048e86af99801459c9');
  }
};

// Load popup form
export const loadPopupForm = () => {
  if (window.mootrack) {
    window.mootrack('loadForm', '5fa6ff5150db482daa926962ae3596f7');
  }
}; 